import { Component } from '@angular/core';

@Component({
  selector: 'app-users',
  template: `
                <div>
                    <router-outlet></router-outlet>
                </div>
             ` ,
})

export class UsersComponent {

}
